import Communities from '@/components/Club/Section/Communities'
import Faqs from '@/components/Club/Section/Faqs'
import HowItWorks from '@/components/Club/Section/HowItWorks'
import Perks from '@/components/Club/Section/Perks'
import Tiers from '@/components/Club/Section/Tiers'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import Image from "next/legacy/image";
import Link from 'next/link'

import { useEffect, useState } from 'react'
const Layout = dynamic(() => import('@components/Layout'))

const navigation = [
    { name: 'How It Works', href: '#howitworks'},
    { name: 'Perks', href: '#perks'},
    { name: 'Tiers', href: '#tiers'},
    { name: 'Communities', href: '#communities'},
    { name: 'FAQ', href: '#faqs'},
];

export default function Club() {
    const [scrollY, setY] = useState(0);
    const handleNavigation = (e) => {
        const window = e.currentTarget;
        setY(window.scrollY);
    };
    useEffect(() => {
        window.addEventListener("scroll", (e) => handleNavigation(e));
        return () => { // return a cleanup function to unregister our function since its gonna run multiple times
            window.removeEventListener("scroll", (e) => handleNavigation(e));
        };
    }, [scrollY]);
    return (
        <Layout pageTitle='Rapidé - Club Member'>
            <div className="scroll-smooth relative top-0 max-w-full mx-auto md:mt-0 sm:mt-[93px] mt-[93px] bg-rapide-yellow">
                <div onClick={()=>{window.scrollTo({top: 0, behavior: 'smooth'});}} className={`${(scrollY > 580) ? 'block': 'hidden'} bg-rapide-yellow/80 rounded-md fixed bottom-4 right-2 z-30 cursor-pointer`}>
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32">
                        <polygon points="16,14 6,24 7.4,25.4 16,16.8 24.6,25.4 26,24 "/>
                        <rect x="4" y="8" width="24" height="2"/>
                        <rect fill="none" width="32" height="32"/>
                    </svg>
                </div>
                <div className="snap-normal snap-start relative flex flex-col justify-center items-center before:content-[''] before:bg-black/50 before:absolute before:top-0 before:left-0 before:bottom-0 before:right-0 bg-cover bg-no-repeat bg-fixed sm:bg-center bg-[center_top_4.84rem] bg-[url('/assets/images/club-member/club-header.webp')] lg:h-[750px] h-[630px]">
                    <div className='sm:absolute relative inset-x-auto md:inset-y-1/4 sm:top-0 -top-10 lg:px-20 md:px-16 sm:px-12 px-4 grid md:grid-cols-2 grid-cols-1 gap-14'>
                        <div className='w-full sm:text-left text-center'>
                            <h1 className='text-rapide-yellow text-5xl pb-4 pt-4'>Earn and Pay with Points</h1>
                            <h1 className='text-rapide-yellow text-4xl pb-8'>Get 1 point every 40 pesos spent</h1>
                            <Link className='text-white bg-rapide-red border border-rapide-red uppercase px-4 py-2 rounded-md font-semibold text-lg' href="/club/sign-up">
                                Join now for FREE
                            </Link>
                        </div>
                        <div className=''>
                            <div style={{boxShadow: '0px 0px 20px #f1f1f1'}} className='relative rounded-3xl'>
                                <Image
                                    alt='rapide-club'
                                    src={'/assets/images/club-member/elite.webp'}
                                    layout="responsive"
                                    height={600}
                                    width={1000}
                                    objectFit="contain"
                                />
                            </div>
                        </div>
                    </div>
                    <div className='absolute bottom-0 w-full text-center'>
                        <a onClick={()=>{
                                window.scrollTo({
                                    top: 631,
                                    behavior: 'smooth'
                                });
                            }}
                            className='text-white cursor-pointer'>
                            <svg className='mx-auto animate-bounce' xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                <path fillRule="evenodd" d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                            </svg>
                        </a>
                    </div>
                </div>
                <nav className={`md:sticky relative lg:top-[125px] md:top-[85px] top-0 grid grid-flow-col bg-white z-10 border-b border-rapide-yellow`}>
                    <ul className="flex md:flex-row flex-col mx-auto items-center uppercase w-full text-center">
                        {navigation.map((nav, index) => {
                            return (
                                <Link key={index} className={`w-full md:border-0 border-b border-gray-300 font-bold whitespace-nowrap lg:px-2 px-1 py-2 lg:mx-1 mx-0 cursor-pointer inline-block relative hover:text-rapide-red hover:!border-b-2 text-rapide-black`} href={nav.href} >
                                    {nav.name}
                                </Link>
                            );
                        })}
                    </ul>
                </nav>
                <HowItWorks/>
                <Perks/>
                <Tiers/>
                <Communities/>
                <Faqs/>
            </div>
        </Layout>
    )
}